<template>
  <el-dialog
    :title="$t('merchantShop.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog"
  >
    <div class="text-center">
      <p>{{ $t('merchantShop.confirmDeleteShop') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('merchantShop.cancel') }}</el-button>
      <el-button type="primary" @click="deleteMerchantShop">
        {{ $t('merchantShop.confirmDelete') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteShop } from '@/api/admin/merchantShopApi'

export default {
  name: 'DeleteMerchantShop',
  data() {
    return {
      dialogVisible: false,
      shopInfo: {}
    }
  },
  methods: {
    open(params) {
      this.dialogVisible = true
      this.shopInfo = params
    },
    closeDialog() {
      this.dialogVisible = false
      this.shopInfo = {}
    },
    async deleteMerchantShop() {
      try {
        await deleteShop(this.shopInfo)
        this.$emit('refresh')
        this.closeDialog()
        this.$message.success(this.$t('merchantShop.deleteSuccess'))
      } catch (error) {
        console.error('删除商铺失败:', error)
        this.$message.error(error.message || this.$t('merchantShop.deleteFailed'))
      }
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
  font-size: 16px;
  margin: 20px 0;
}
</style>